import { Component } from 'react';
import {connect} from "react-redux";
import {compose} from "redux";
import Dialog from '@mui/material/Dialog';
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import IconButton from '@mui/material/IconButton';
import ValidateIcon from '@mui/icons-material/Check';
import { withStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import CustomizedTextField from '../Input/CustomizedTextField';
import { setSolutions } from '../../redux/analyseRisques/analyseRisquesActions'

const styles = {
    appBar: {
        position: 'relative',
        marginBottom: '10px',
    },
    flex: {
        flex: 1,
    },
};

class CommentModal extends Component {

    constructor(props){
        super(props);

        this.props.onRef(this);
        this.state = {
            commentValue: props.currentSolution.comment,
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    validate(){
        const solutions = this.props.solutions;
        let solution = solutions.find((c) => c.id === this.props.currentSolution.id);
        solution.comment = this.state.commentValue;
        this.props.setSolutions(solutions, this.props.currentRisk.id, this.props.currentRisks, this.props.moduleSpp);
        this.props.close();
    }

    commentChange(e){
        this.setState({
            commentValue: e.target.value,
        })
    }

    render() {
        const { classes } = this.props;

        return (
            <div  className="col-lg-12 col-md-12 col-sm-12 col-12">
                <Dialog aria-labelledby="simple-dialog-title" fullWidth open={this.props.open} onClose={this.props.close}>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton color="inherit" onClick={this.props.close} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                Commentaire
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <DialogContent className="container">
                        <CustomizedTextField
                            id="comment"
                            label={"Commentaire"}
                            className="full_size"
                            multiline
                            onChange={this.commentChange.bind(this)}
                            value={this.props.currentSolution.comment}
                        />
                    </DialogContent>
                    <DialogActions>
                        <IconButton onClick={this.validate.bind(this) }>
                            <ValidateIcon />
                        </IconButton>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        moduleSpp: state.analysesRisques.moduleSpp,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSolutions: (currentSolutions, currentRiskId, currentRisks) => dispatch(setSolutions(currentSolutions, currentRiskId, currentRisks)),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(CommentModal);
